import { Button } from '@/components/shadcn/button'
import { SheetTrigger } from '@/components/shadcn/sheet'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { IconEditOutline } from '@icons/IconEditOutline'
import { SheetContentAction } from './SheetContentAction'
import { DataTableV2GroupConfig, DataTableV2SheetContentAction } from '../types'
import { DataTableV2DataRow } from '../types'
import { FormData } from '../../DataFormComponent/types'
import { JsonFormPropertyV2 } from '../../FormComponent/types'

export function GroupEditAction({
  groupConfig,
  formData,
  onSubmitOverride,
}: {
  groupConfig: DataTableV2GroupConfig
  formData: DataTableV2DataRow
  onSubmitOverride: (groupId: string, data: FormData, formProperties: JsonFormPropertyV2[]) => void
}) {
  const trigger = (
    <TooltipButton tooltip="Edit group">
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="size-6">
          <IconEditOutline />
        </Button>
      </SheetTrigger>
    </TooltipButton>
  )
  return (
    <SheetContentAction
      action={
        {
          type: 'sheet-content',
          id: 'group-edit',
          label: 'Edit group',
          icon: 'IconEditOutline',
          content: { contentId: groupConfig.formSchemaContentId, contentType: 'data-form' },
        } as DataTableV2SheetContentAction
      }
      trigger={trigger}
      formData={formData}
      isDisabled={false}
      onSubmitOverride={onSubmitOverride}
    />
  )
}
